const configuredApiUrl = process.env.REACT_APP_API_URL?.replace(/\/$/, '');

if (!configuredApiUrl && process.env.NODE_ENV === 'production') {
  throw new Error('REACT_APP_API_URL must be configured for production builds');
}

export const API_BASE_URL = configuredApiUrl || 'http://localhost:3000/api/v1';

const isLocalDevelopmentUrl = /^http:\/\/(localhost|127\.0\.0\.1)(:|\/)/.test(API_BASE_URL);
if (process.env.NODE_ENV === 'production' && !isLocalDevelopmentUrl && !API_BASE_URL.startsWith('https://')) {
  throw new Error('REACT_APP_API_URL must use HTTPS in production');
}
